import { render, staticRenderFns } from "./productInfoBanner.vue?vue&type=template&id=7d5eef22&"
import script from "./productInfoBanner.vue?vue&type=script&lang=js&"
export * from "./productInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./productInfoBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports